module.exports = __webpack_public_path__ + "img/join.ed26e5e4.svg";